
import {observable} from "mobx";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";



export class SeparatorControlOptions extends PDFControlBaseOptions{
    Type:ControlTypeEnum.Separator;
    @observable
    Orientation:SeparatorOrientationEnum;
    @observable
    BorderSize:string;
    @observable
    BorderStyle:string;
    @observable
    BorderColor:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=ControlTypeEnum.Separator;
        this.Orientation=SeparatorOrientationEnum.Horizontal;
        this.Styles.Width='80%';
        this.BorderSize='1px';
        this.BorderStyle='solid';
        this.BorderColor='#000000';
        this.HideFromTemplateDesigner=true;

    }
}

export enum SeparatorOrientationEnum{
    Vertical='Vertical',
    Horizontal='Horizontal'
}